const REACT_APP_ENV = (window as any).REACT_APP_ENV ?? process.env.REACT_APP_ENV ?? "test";
const BACKEND_URL =
    REACT_APP_ENV === "prod"
        ? "https://catermat-erp-backend-prod-475202341553.europe-west4.run.app"
        : "https://catermat-erp-backend-475202341553.europe-west4.run.app";

export { REACT_APP_ENV, BACKEND_URL };
